import api from '@/api';

const { $academic, $pricing } = api;

export const { $sections, $terms, $departments, $subjects, $student } = $academic;
export const { $types } = $pricing;
